import { useEffect } from "react";
import { useState } from "react";
import "./createconferencereservation.css";
import DatePicker from "react-datepicker";
import API from "src/API";
import toast from "react-hot-toast";

const CreateConferenceReservation = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [birthDate, setBirthDate] = useState(new Date());
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [nbPersonne, setNbPersonne] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endtDate, setEndDate] = useState(new Date());
  const [arrivalTime, setArrivalTime] = useState("");
  const [menu, setMenu] = useState([]);
  const [salles, setSalles] = useState([]);

  const [allSalle, setAllSalles] = useState([]);
  const [allMenus, setAllMenus] = useState([]);


 
  useEffect(() => {
    API.get("salle").then((resp) => {
      setAllSalles(resp.data.data);
    });
    API.get("menu").then((resp) => {
      setAllMenus(resp.data.data);
    });
  }, []);

  const post = () => {
    toast.promise(
      API.post("salleReservation", {
        startDate: startDate,
        finishDate: endtDate,
        firstname: firstname,
        lastname: lastname,
        email: email,
        phoneNum: phone,
        birthDate: birthDate,
        nbPersonne: nbPersonne,
        arrivalTime: arrivalTime,
        menus: menu,
        salles: salles,
      }),
      {
        success: "Conference reservation created succeffully",
        error: "Something went wrong",
        loading: "Creating conference reservation ...",
      }
    );
  };

  return (
    <div className="createconferencereservation">
      <div className="title">
        <h2>Create New Service</h2>
      </div>
      <div className="content">
        <div className="form">
          <div className="inputs">
            <div className="inline_inputs">
              <div className="input">
                <span>First Name</span>
                <input
                  placeholder="Mohamed"
                  value={firstname}
                  onChange={(e) => {
                    setFirstname(e.target.value);
                  }}
                />
              </div>
              <div className="input">
                <span>Last Name</span>
                <input
                  placeholder="ex"
                  value={lastname}
                  onChange={(e) => {
                    setLastname(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="inline_inputs">
              <div className="input">
                <span>Birthdate</span>
                <DatePicker
                  selected={birthDate}
                  onChange={(date) => setBirthDate(date)}
                />
              </div>
              <div className="input"></div>
            </div>
            <div className="inline_inputs">
              <div className="input">
                <span>Email</span>
                <input
                  placeholder="noreply@parkmallhotel.com"
                  value={email}
                  type="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </div>
              <div className="input">
                <span>Phone Number</span>
                <input
                  placeholder="+21300000000"
                  value={phone}
                  type="number"
                  onChange={(e) => {
                    setPhone(e.target.valueAsNumber);
                  }}
                />
              </div>
            </div>
            <div className="inline_inputs">
              <div className="input">
                <span>Number of invited people</span>
                <input
                  placeholder="150"
                  value={nbPersonne}
                  type="number"
                  onChange={(e) => {
                    setNbPersonne(e.target.valueAsNumber);
                  }}
                />
              </div>
              <div className="input">
                <span>Arrival Time</span>
                <input
                  placeholder="8:00"
                  value={arrivalTime}
                  type="number"
                  onChange={(e) => {
                    setArrivalTime(e.target.valueAsNumber);
                  }}
                />
              </div>
            </div>
            <div className="inline_inputs">
              <div className="input">
                <span>Start Date</span>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>
              <div className="input">
                <span>End Date</span>
                <DatePicker
                  selected={endtDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>
            </div>
            <div className="inline_inputs">
              <div className="input">
                <span>Conrference Room</span>
                <select
                  defaultValue="DEFAULT"
                  onChange={(e) => {
                    setSalles([e.target.value]);
                  }}
                >
                  <option value="DEFAULT" disabled>
                    Select Conference Room
                  </option>
                  {allSalle.map((e, i) => {
                    return (
                      <option key={i} value={e.id}>
                        {e.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="input">
                <span>Food Menu</span>
                <select
                  defaultValue="DEFAULT"
                  onChange={(e) => {
                    setMenu([e.target.value]);
                  }}
                >
                  <option value="DEFAULT" disabled>
                    Select The menu
                  </option>
                  {allMenus.map((e, i) => {
                    return (
                      <option key={i} value={e.id}>
                        {e.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
          <div className="buttons">
            <div
              className="full_button"
              onClick={() => {
                post();
              }}
            >
              Create
            </div>
            <div className="noline_button" onClick={()=>{
              window.location = "/reservations"
            }}>Cancel</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateConferenceReservation;
